(function () {
  function revealReviewForm() {
    const panel = document.getElementById('write-a-review');
    if (!panel) return;
    panel.open = true;
    if (panel.dataset.twOpening === 'yes') return;
    panel.dataset.twOpening = 'yes';
    let attempts = 0;
    function openJudgeMe() {
      const form = panel.querySelector('.jdgm-form-wrapper');
      if (form && window.getComputedStyle(form).display !== 'none') {
        panel.dataset.twOpening = 'no';
        return;
      }
      const action = panel.querySelector('.jdgm-write-rev-link, .jm-write-review-button');
      if (action) {
        action.click();
        panel.dataset.twOpening = 'no';
        return;
      }
      attempts += 1;
      if (attempts < 12) window.setTimeout(openJudgeMe, 250);
      else panel.dataset.twOpening = 'no';
    }
    window.setTimeout(openJudgeMe, 150);
  }
  function checkHash() {
    if (window.location.hash === '#write-a-review') revealReviewForm();
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-tw-write-review]')) revealReviewForm();
  });
  window.addEventListener('hashchange', checkHash);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkHash, { once: true });
  } else checkHash();
})();